import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import GridCellErrorBoundary from '../GridCellErrorBoundary';
import KingpinBadge, { KingpinBadgeType } from '../../kingpin/atoms/Badge';
import Cell from '../V5Gadget/Matrix/Cell';

export const BADGE_CELL = 'BADGE_CELL';

const BadgeCell = <TData = any,>({
  value,
}: ICellRendererParams<
  TData,
  { text: string; badgeType: KingpinBadgeType }
>) => {
  if (!value) {
    return null;
  }
  if (typeof value !== 'object') {
    return null;
  }
  if (!value.text || !value.badgeType) {
    return null;
  }
  const { text, badgeType } = value;

  return (
    <Cell>
      <div>
        <KingpinBadge badgeType={badgeType} text={text} />
      </div>
    </Cell>
  );
};

const Gate = <TData = any,>(
  params: ICellRendererParams<
    TData,
    { text: string; badgeType: KingpinBadgeType }
  >,
) => {
  return (
    <GridCellErrorBoundary
      params={params}
      childComponent={<BadgeCell {...params} />}
    />
  );
};

export default Gate;
